import React from "react";
import withMediaQueries from "../../../hoc/withMediaQueries";
import "./header.scss";
import PropTypes from "prop-types";
import FeatureToggle from '../../FeatureToggle/feature.toggle';

export class Header extends React.Component {
  render() {
    const { screenLargerThan, mediaQueriesList } = this.props.screenSizeUtils;
    return (
      <React.Fragment>
        <FeatureToggle key="toggleOn" featureName="cl_aa_cobranding_header_update">
          <section className="cobranded-page-header-toggle bottom-shadow">
            <nav className="navbar">
              <a className="navbar-brand">
                <span className="american-airline-logo"/>
                <span className="barclays-logo-blue-res"/>
              </a>
              <ul>
                <li><a className="bcus-text-cyan check-my-app-text text-color-aa" data-track="topNav" id="topOfPage" href="/applicationcenter">Check My Application</a></li>
                <li><a className="bcus-text-cyan log-in-text text-color-aa" data-track="topNav" href="https://loans.barclaysus.com/pages/home">Log In</a></li>
              </ul>
              { screenLargerThan(mediaQueriesList.xxs) &&
              <div>
                <small className="powered-by">POWERED BY</small>
                <p><span className="barclays-logo-blue" /></p>
              </div>
              }
            </nav>
          </section>
        </FeatureToggle>
        <FeatureToggle key="toggleOff" featureName="cl_aa_cobranding_header_update" showWhenFeatureToggleOff={true}>
          <section className="cobranded-page-header bottom-shadow">
            <nav className="navbar">
              <a className="navbar-brand">
                <span className="american-airline-logo"/>
              </a>
              { screenLargerThan(mediaQueriesList.xxs) &&
              <div>
                <small className="powered-by">POWERED BY</small>
                <p><span className="barclays-logo-blue" /></p>
              </div>
              }
            </nav>
          </section>
        </FeatureToggle>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  screenSizeUtils: PropTypes.shape({
    mediaQueriesList: PropTypes.object.isRequired,
    screenLargerThan: PropTypes.func.isRequired
  }).isRequired
};

export default withMediaQueries(Header);
